module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG38fdf2f0c3e1f12e9ba673d6cf4e413d.38fdf2f0.png";